module.exports = __webpack_public_path__ + "img/red.ede28147.png";